export default __webpack_public_path__ + "static/media/Ruby Ring of Strength.79617074.jpg";